import React from 'react';
import { Badge } from 'react-bootstrap';
import Avatar from './Avatar';
import NotificationCenter from './NotificationCenter';
import './Header.css';

const Header = ({ currentPage, onNavigate, user, onLogout }) => {
  const externalLinks = [
    { label: 'О сервисе', href: 'https://fixatorapp.ru/about/' },
    { label: 'Кейсы', href: 'https://fixatorapp.ru/cases/' },
    { label: 'Тарифы', href: 'https://fixatorapp.ru/plans/' },
    { label: 'Блог', href: 'https://fixatorapp.ru/blog/' },
    { label: 'Контакты', href: 'https://fixatorapp.ru/contacts/' },
  ];

  const internalLinks = [
    { key: 'home', label: 'Главная' },
    { key: 'profile', label: 'Личный кабинет' },
    { key: 'messages', label: 'Сообщения' },
    { key: 'training', label: 'Обучение' },
    ...(user?.role === 'admin' ? [{ key: 'admin', label: 'Админ-панель' }] : []),
  ];

  return (
    <header className="app-header">
      <div className="app-header__top">
        <div className="app-header__logo">
          <a href="https://fixatorapp.ru/" target="_blank" rel="noopener noreferrer">
            <img
              src="/img/logo-fixator.svg"
              alt="Fixator"
              className="app-header__logo-img"
            />
          </a>
          <div className="app-header__subtitle">
            Защита Ваших авторских прав <br />в судах по всей России
          </div>
        </div>

        <div className="app-header__links">
          <nav aria-label="Навигация внешняя" className="app-header__external">
            {externalLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="app-header__cabinet">
            <a href="https://fixator-app.ru/" target="_blank" rel="noopener noreferrer">
              Личный кабинет
            </a>
          </div>
        </div>
      </div>

      {/* Внутренняя навигация приложения */}
      <div className="app-header__nav">
        {internalLinks.map((item) => {
          const active = currentPage === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onNavigate && onNavigate(item.key)}
              className={`app-header__nav-btn${active ? ' app-header__nav-btn--active' : ''}`}
            >
              {item.label}
            </button>
          );
        })}
        <div className="app-header__spacer" />
        <div className="app-header__user">
          <Avatar user={user} size={28} showBorder />
          <span className="app-header__user-name">{user?.login || user?.username}</span>
          {user?.role === 'admin' && (
            <Badge bg="danger" style={{ fontSize: '11px' }}>
              {user.role}
            </Badge>
          )}
          <NotificationCenter />
          <button
            onClick={onLogout}
            style={{
              border: '1px solid #dcdbea',
              background: '#fff',
              color: '#c0392b',
              borderRadius: '8px',
              padding: '6px 12px',
              fontSize: '12px',
              cursor: 'pointer',
            }}
          >
            Выйти
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

